import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords } from "../../services/api.service";
import { exportPageData } from "./ScrabApprovalFile";
import moment from "moment";

const breadcrumbItems = [];

const ScrabApprovalList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
  }, [searchKeyword, page, pageSize]);
  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    handleExportData(projectId, contractor_id);
  }, []);
  const getData = async (Id, contractor_id) => {
    try {
      const payload = {
        modelName: "outwards",

        whereCondition: {
          type: "Scrab",
          project_id: Id,
          contractor_id: contractor_id, // Login User ID
        },
        relations: [
          {
            module: "outward_items",
            moduleAs: "outward_items",
          },
          {
            module: "projects",
            moduleAs: "project",
          },

          {
            module: "user_masters",
            moduleAs: "customer",
          },
          {
            module: "warehouse_masters",
            moduleAs: "warehouse",
          },
          {
            module: "user_masters",
            moduleAs: "contractor",
          },
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "outward_no",
            "warehouse.warehouse_name",
            "contractor.first_name",
            "createdBy.first_name",
          ],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      // Assign an `index` property starting from 1
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/outward-create");
  };

  const handleViewClick = (id) => {
    navigate(`/scrap-approval-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "OUTWARD NO",
        accessor: (row) =>
          row?.outward_no && row?.outward_no ? row?.outward_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "WAREHOUSE",
        accessor: (row) =>
          row?.warehouse && row?.warehouse?.warehouse_name
            ? row?.warehouse?.warehouse_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ASSIGNED TO",
        accessor: (row) =>
          row?.contractor && row?.contractor?.first_name
            ? row?.contractor?.first_name + " " + row?.contractor?.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ASSIGNED BY",
        accessor: (row) =>
          row?.createdBy && row?.createdBy?.first_name
            ? row?.createdBy?.first_name + " " + row?.createdBy?.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "SCRAP STATUS",
        accessor: "scrab_status",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === "Rejected" ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                Rejected
              </span>
            ) : value === "Approved" ? (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Approved
              </span>
            ) : (
              <span className="badge bg-warning-subtle text-warning text-uppercase">
                Pending
              </span>
            )}
          </div>
        ),
      },

      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleExportData = async (projectId, contractor_id) => {
    try {
      exportPageData.data.whereCondition = {
        type: "Scrab",
        project_id: projectId,
        contractor_id: contractor_id,
      };
      const responseData = await getRecords(
        exportPageData?.data,
        "/getRecords"
      );
      console.log("responseData?.data", responseData?.data);
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        "OUTWARD NO": item?.outward_no || "-",
        WAREHOUSE: item?.warehouse?.warehouse_name || "-",
        "ASSIGNED TO":
          item?.contractor?.first_name + " " + item?.contractor?.last_name ||
          "-",
        "ASSIGNED BY":
          item?.createdBy?.first_name + " " + item?.createdBy?.last_name || "-",
        "SCRAP STATUS":
          item.scrab_status == "Approved"
            ? "Approved"
            : item.scrab_status == "Rejected"
            ? "Rejected"
            : "Pending",
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Scrap Approval List"
              breadcrumbItems={breadcrumbItems}
            />
            {/* <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Outward
            </Button> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ScrabApprovalList;
